import { useState } from "react";
import PropTypes from "prop-types";
import {greyishBlue50} from "assets/jss/main";

// TODO: fix with better code after demo
function TabItem({ label, active, onClick }) {
    return (
        <button
            onClick={onClick}
            style={{
                padding: "8px 16px",
                borderRadius: "8px",
                border: "none",
                backgroundColor: active ? "#ffffff" : "transparent",
                color: active ? "#111827" : "#9ca3af",
                fontWeight: active ? "700" : "400",
                fontSize: "14px",
                cursor: "pointer",
                fontFamily: "inherit",
                boxShadow: active ? "0 1px 4px rgba(0,0,0,0.1)" : "none",
                transition: "all 0.15s ease",
                whiteSpace: "nowrap",
            }}
        >
            {label}
        </button>
    );
}

TabItem.propTypes = {
    label: PropTypes.string.isRequired,
    active: PropTypes.bool,
    onClick: PropTypes.func,
};


function EnrichmentTab({ tabs = [], onChange = () => {} }) {
    const [activeIndex, setActiveIndex] = useState(0);

    const handleClick = (index) => {
        setActiveIndex(index);
        onChange(tabs[index], index);
    };

    return (
        <div
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "4px",
                padding: "4px",
                borderRadius: "12px",
                backgroundColor: greyishBlue50,
                marginBottom: '12px'
            }}
        >
            {tabs.map((tab, index) => (
                <TabItem
                    key={index}
                    label={tab}
                    active={activeIndex === index}
                    onClick={() => handleClick(index)}
                />
            ))}
        </div>
    );
}

EnrichmentTab.propTypes = {
    tabs: PropTypes.arrayOf(PropTypes.string).isRequired,
    onChange: PropTypes.func,
};

export default EnrichmentTab;
